import i18n from 'i18next'
import type React from 'react'
import { I18nextProvider } from 'react-i18next'
import { TooltipProvider } from '~/components/ui/tooltip'
import { AuthProvider } from './AuthProvider.client'
import { DeviceProvider } from './DeviceProvider'

function AppProviders({ children }: { children: React.ReactNode }) {
    return (
        <I18nextProvider i18n={i18n} defaultNS={'common'}>
            <AuthProvider>
                <DeviceProvider>
                    <TooltipProvider delayDuration={250}>{children}</TooltipProvider>
                </DeviceProvider>
            </AuthProvider>
        </I18nextProvider>
    )
}

export default AppProviders
